export default "__VITE_ASSET__5d6c01ef__"